/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createOrderDtoFromDiscriminatorValue, type ErrorResponse, type InternalErrorResponse, type OrderDto } from '../../../models/index.js';
// @ts-ignore
import { CartEventsRequestBuilderRequestsMetadata, type CartEventsRequestBuilder } from './cartEvents/index.js';
// @ts-ignore
import { EmailRequestBuilderRequestsMetadata, type EmailRequestBuilder } from './email/index.js';
// @ts-ignore
import { EmailsRequestBuilderRequestsMetadata, type EmailsRequestBuilder } from './emails/index.js';
// @ts-ignore
import { PdfRequestBuilderRequestsMetadata, type PdfRequestBuilder } from './pdf/index.js';
// @ts-ignore
import { SignatureRequestBuilderRequestsMetadata, type SignatureRequestBuilder } from './signature/index.js';
// @ts-ignore
import { SmsRequestBuilderRequestsMetadata, type SmsRequestBuilder } from './sms/index.js';
// @ts-ignore
import { StatusRequestBuilderRequestsMetadata, type StatusRequestBuilder } from './status/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/orders/{-id}
 */
export interface ItemRequestBuilder extends BaseRequestBuilder<ItemRequestBuilder> {
    /**
     * The cartEvents property
     */
    get cartEvents(): CartEventsRequestBuilder;
    /**
     * The email property
     */
    get email(): EmailRequestBuilder;
    /**
     * The emails property
     */
    get emails(): EmailsRequestBuilder;
    /**
     * The pdf property
     */
    get pdf(): PdfRequestBuilder;
    /**
     * The signature property
     */
    get signature(): SignatureRequestBuilder;
    /**
     * The sms property
     */
    get sms(): SmsRequestBuilder;
    /**
     * The status property
     */
    get status(): StatusRequestBuilder;
    /**
     * Returns one order by its id. Administrators see any order in the organization; a customer sees only their own orders; a sales rep sees the orders of customers they are allowed to see — every customer when their organization record has Can view all customers switched on, otherwise only customers whose RepNumber is one of theirs. An order the caller may not see returns 404 rather than 403, so an order id cannot be used to confirm that an order exists.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<OrderDto>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {ErrorResponse} error when the service returns a 404 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<ItemRequestBuilderGetQueryParameters> | undefined) : Promise<OrderDto | undefined>;
    /**
     * Returns one order by its id. Administrators see any order in the organization; a customer sees only their own orders; a sales rep sees the orders of customers they are allowed to see — every customer when their organization record has Can view all customers switched on, otherwise only customers whose RepNumber is one of theirs. An order the caller may not see returns 404 rather than 403, so an order id cannot be used to confirm that an order exists.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<ItemRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * Returns one order by its id. Administrators see any order in the organization; a customer sees only their own orders; a sales rep sees the orders of customers they are allowed to see — every customer when their organization record has Can view all customers switched on, otherwise only customers whose RepNumber is one of theirs. An order the caller may not see returns 404 rather than 403, so an order id cannot be used to confirm that an order exists.
 */
export interface ItemRequestBuilderGetQueryParameters {
    /**
     * For a sales rep who belongs to several organizations: the organization to read from.It must be one of the organizations the caller's OrgCodes header grants.
     */
    useOrganizationId?: string;
}
/**
 * Uri template for the request builder.
 */
export const ItemRequestBuilderUriTemplate = "{+baseurl}/api/orders/{%2Did}{?useOrganizationId*}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const ItemRequestBuilderNavigationMetadata: Record<Exclude<keyof ItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    cartEvents: {
        requestsMetadata: CartEventsRequestBuilderRequestsMetadata,
    },
    email: {
        requestsMetadata: EmailRequestBuilderRequestsMetadata,
    },
    emails: {
        requestsMetadata: EmailsRequestBuilderRequestsMetadata,
    },
    pdf: {
        requestsMetadata: PdfRequestBuilderRequestsMetadata,
    },
    signature: {
        requestsMetadata: SignatureRequestBuilderRequestsMetadata,
    },
    sms: {
        requestsMetadata: SmsRequestBuilderRequestsMetadata,
    },
    status: {
        requestsMetadata: StatusRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const ItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: ItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createOrderDtoFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
